@if (helpIsAvailable) {
	<div class="h-100 help-wrapper zindex-helpdesk">
		<button class="btn btn-primary p-2 help-toggle-button" [class.open]="helpIsVisible" (click)="toggleHelpContent()">
			<img
				class="mask-settings bg-white grid-mask-img"
				[class.arrow-right-white-mask-img]="helpIsVisible"
				[class.help-mask-img]="!helpIsVisible" />
		</button>
		@if (closeIsVisible) {
			<button class="close" style="position: absolute; right: 0.5rem; top: 0.25rem; z-index: 2" (click)="toggleHelpContent()">
				×
			</button>
		}
		<div id="helpContent" class="h-100 administration-help-content relative" [class.visible]="helpIsVisible">
			<h3 class="px-4 pt-4">
				{{ 'administration-help.help' | translate }}
			</h3>
			<div id="helpContentScrollArea" class="px-4 pt-2 pb-4" [innerHTML]="helpContent | safeHtml"></div>
		</div>
	</div>
}
